class ContactFile {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const fileBox = document.querySelector('.upload-box');
    const fileName = document.querySelector('.upload-file');

    // fileName.addEventListener('change', () => {
    //   console.log("変更が加えられました");
    // });
  }
}
